import {TrackableEntity} from './data/ChangeTrackable';
import {IDictionary} from './data/TrackingModule';
import {DBMappingInfo} from '../framework.core/data/DBMappingInfo';
import {AcctBLHd} from './AcctBLHd';
import {ApDetail} from './ApDetail';
import {OpAcct} from './OpAcct';
import { APInfoDetail } from './APInfoDetail';
import { AcctHeadType, FormSubType, FormType } from '../fms.enum';
import _ from 'lodash';
import * as XCol from '../framework.core/XExportColumn';

/**
 * Index of action buttons
 */
export enum CmdType {
    None = -1,
    Amend = 0,      // Also 5
    Credit,
    Void,
    Confirm,
    Cancel,         // Also 7, 9, 11, 13
    PaidAmend = 5,    
    CancelCredit = 6,
    CancelVoid = 8,
    ReceiveCredit = 10,
    CancelRCredit = 12
}
export class ApHd extends TrackableEntity {
    id: number = 0;
    vendorId: number = 0;
    vendorName: string = '';
    vendorRefNo: string = '';
    refNo: string = '';
    dutyCustomerId: number = 0;
    dutyAgentId: number = 0;
    dutyCustomerName: string = '';
    dutyAgentName: string = '';
    branch: string = '';
    billNo: string = '';
    billDate: string | null = null;
    postDate: string | null = null;
    terms: number = 0;
    dueDate: string | null = null;
    currency: string = '';
    currencyDecimal: number = 0;
    billAmt: number = 0;
    paidAmt: number = 0;
    advRecAmt: number = 0;
    advRecDisplayAmt: number = 0;
    displayPaidAmt: number = 0;
    balanceDue: number = 0;
    lastPaidChkNo: string = '';
    lastPaidDate: string | null = null;
    billReceived: boolean = false;
    confirmed: boolean = false;
    useLocalLanguage: boolean = false;
    prepaidExStatus: boolean = false;
    block: boolean = false;
    billMemo: string = '';
    exRate1: number = 0;
    exRate2: number = 0;
    exRate3: number = 0;
    exRate4: number = 0;
    tVatAmt: number = 0;
    tlAmount: number = 0;
    payGlNo: string = '';
    descript: string = '';
    dutyAmt: number = 0;
    dutyLAmt: number = 0;
    cAmount: number = 0;
    invCur1: string = '';
    invCur2: string = '';
    invCur3: string = '';
    invCur4: string = '';
    invCur1Decimal: number = 0;
    invCur2Decimal: number = 0;
    invCur3Decimal: number = 0;
    invCur4Decimal: number = 0;
    void: number = 0;
    isCredit: number = 0;
    hold: boolean = false;
    holdUser: string = '';
    holdReason: string = '';
    remarksYN: boolean = false;
    remarks: string = '';
    remarkUser: string = '';
    approved: boolean = false;
    appPaidDate: string | null = null;
    approvedUser: string = '';
    tbName: string = '';
    tbId: number = 0;
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;
    agent: number = 0;
    jobName: string = '';
    isHybrid: boolean = false;
    originId: number = 0;
    originDepoId: number = 0;
    originDepoDetailId: number = 0;
    originAmt: number = 0;
    orgPaidAmt: number = 0;
    orgAdvRecAmt: number = 0;
    creditBillingCode: string = '';
    etf: string = '';
    isSalesTaxReturn: boolean = false;
    voidDate: string | null = null;
    voidBy: string = '';
    blHdInfo: AcctBLHd | null = null;
    billDetail: ApDetail[] = [];
    opAccts: OpAcct[] = [];
    draftPaid: boolean = false;
    prepaidLinkCnt: number = 0;
    taxReturnLinkCnt: number = 0;
    
    invDBCur1: string = '';
    invDBCur2: string = '';
    invDBCur3: string = '';
    invDBCur4: string = '';
    apInfoDetailList: APInfoDetail[] = [];

    pcurTotal: number = 0;
    cur1Total: number = 0;
    cur2Total: number = 0;
    cur3Total: number = 0;
    cur4Total: number = 0;

    isLockCur1: boolean = false;
    isLockCur2: boolean = false;
    isLockCur3: boolean = false;
    isLockCur4: boolean = false;
    
    // cloud
    draft: boolean = false;
    displayDraft: boolean = false;
    isClassify: boolean = false;
    attentionTo: string = '';
    cannotDraft: boolean = false;
    jobType: string = '';
    lastPaymentId: number = 0;
    lastPaymentType: string = '';
    lastPaymentETF: number = 0;
    lastPaymentIsAgentPay: number = 0;
    /**
     * For GetJobSalesCost
     */
    crDbNo: string = '';

    /**
     * To control view
     */
    hdIsClosed: boolean = false;
    hdOpType: AcctHeadType = AcctHeadType.None;
    hdSubType: FormSubType = FormSubType.None;
    formType: FormType = FormType.None;
    srcJobName: string = '';
    srcJobId: number = 0;
    availableCurrencies: string[] = [];
    creditDate: string|null = null;
    creditBy: string|null = null;
    enableDutyAgent: boolean = false;
    enableDutyCustomer: boolean = false;
    priCurTotal: number = 0;
    maxBillNoLength: number = 25;
    hdMaxCreditAmt: number = 0;
    hdOriginPaidAmt: number = 0;
    hdOriginInvAmt: number = 0;
    hdOriginId: number = 0;
    hdPreOriginId: number = 0;
    hdPrePaymentId: number = 0;

    // Charge Type 항목을 설정하기 위해서 추가
    usedDutyType: number = 0;
    isDutyJob: boolean = false;
    useDutyItem: number = 0;
    tableType: string = '';
    // Charge Type End

    // Credit Card Payment 기능을 위한 필드
    ccPay: boolean = false;
    creditCardPaidTo: number = 0; 
    creditCardId: number = 0;
    ccPrefix: string | null = '';
    ccRefNo: string = '';
    ccRefNo2: string | null = '';
    type: string = '';
    exRate: number = 0;
    ccAmt: number = 0;
    // Credit Card Payment End

    // E Pay 필드
    ePay: boolean = false;
    ePayId: number = 0;
    ePayType: string = '';  // E(EPay), C(CCPay)

    // for cloud
    isUserAction: boolean = false;
    // defaultCreditCardName: string | null = '';
    defaultCreditCardId: number = 0;
    defaultCCEntity: number = 0;
    needsRefresh: boolean = false;
    periodActionDate: string | null = null;

    paid: string = 'N';


    fileClose: string ='';

    constructor(init?:Partial<ApHd>) {
        super();
        this.key='id';
        //Object.assign(this, init);
        this.applyInitDataExcludingNull(this, init);
        this.noTrackProps.push('id', 'dutyCustomerName', 'dutyAgentName', 'currencyDecimal',
        'invCur1Decimal', 'invCur2Decimal', 'jobName', 'isHybrid', 'originId', 'originDepoId', 'originDepoDetailId', 'originAmt', 'orgPaidAmt', 'orgAdvRecAmt', 'creditBillingCode', 'etf', 'isSalesTaxReturn', 'voidDate', 'voidBy', 'blHdInfo', 'apInfoDetailList',
        'availableCurrencies', 'creditDate', 'creditBy', 'enableDutyAgent', 'enableDutyCustomer','paid',
        'hdIsClosed', 'hdOpType', 'priCurTotal', 'maxBillNoLength', 'paidAmt', 'displayPaidAmt', 'balanceDue', 'hdSubType', 'formType', 'tVatAmt', 'isDutyJob', 'usedDutyType', 'useDutyItem', 'tableType', 'ccPrefix', 'ccRefNo2',
        'defaultCreditCardId', 'defaultCCEntity', 'displayDraft', 'isUserAction', 'needsRefresh');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();

        if(this.billDetail.length > 0) {
            this.billDetail = this.billDetail.map(d => new ApDetail(d));
        } else {
            this.billDetail = [];
        }

        if(this.opAccts.length > 0) {
            this.opAccts = this.opAccts.map(o => new OpAcct(o));
        } else {
            this.opAccts = [];
        }
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicmap = ApHd.dicFieldMappings;
        _.keys(ApDetail.dicFieldMappings).forEach(k => {
            dicmap[`billDetail.${k}`] = ApDetail.dicFieldMappings[k];
        });

        _.keys(OpAcct.dicFieldMappings).forEach(k => {
            dicmap[`opAccts.${k}`] = OpAcct.dicFieldMappings[k];
        });
        return dicmap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_APHD' }),
        'tbName': new DBMappingInfo({ field: 'F_TBName', table: 'T_APHD' }),
        'tbId': new DBMappingInfo({ field: 'F_TBId', table: 'T_APHD' }),
        'vendorId': new DBMappingInfo({ field: 'F_PayTo', table: 'T_APHD' }),
        'creditCardId': new DBMappingInfo({ field: 'F_CreditCardId', table: 'T_APHD' }),
        'creditCardPaidTo': new DBMappingInfo({ field: 'F_CCPayTo', table: 'T_APHD' }),
        'vendorRefNo': new DBMappingInfo({ field: 'F_YourRef', table: 'T_APHD' }),
        'refNo': new DBMappingInfo({ field: 'F_RefNo', table: 'T_APHD' }),
        'dutyCustomerId': new DBMappingInfo({ field: 'F_DutyEntity', table: 'T_APHD' }),
        'dutyAgentId': new DBMappingInfo({ field: 'F_DutyAgent', table: 'T_APHD' }),
        'billNo': new DBMappingInfo({ field: 'F_InvoiceNo', table: 'T_APHD' }),
        'billDate': new DBMappingInfo({ field: 'F_InvoiceDate', table: 'T_APHD' }),
        'postDate': new DBMappingInfo({ field: 'F_PostDate', table: 'T_APHD' }),
        'terms': new DBMappingInfo({ field: 'F_Terms', table: 'T_APHD' }),
        'dueDate': new DBMappingInfo({ field: 'F_DueDate', table: 'T_APHD' }),
        'currency': new DBMappingInfo({ field: 'F_Currency', table: 'T_APHD' }),
        'billAmt': new DBMappingInfo({ field: 'F_InvoiceAmt', table: 'T_APHD' }),
        'billReceived': new DBMappingInfo({ field: 'F_Invoiced', table: 'T_APHD' }),
        'confirmed': new DBMappingInfo({ field: 'F_Confirmed', table: 'T_APHD' }),
        'useLocalLanguage': new DBMappingInfo({ field: 'F_UseLocalLanguage', table: 'T_APHD' }),
        'prepaidExStatus': new DBMappingInfo({ field: 'F_PrepaidExStatus', table: 'T_APHD' }),
        'block': new DBMappingInfo({ field: 'F_Block', table: 'T_APHD' }),
        'billMemo': new DBMappingInfo({ field: 'F_Memo', table: 'T_APHD' }),
        'invDBCur1': new DBMappingInfo({ field: 'f_cur1', table: 'T_APHD' }),
        'invDBCur2': new DBMappingInfo({ field: 'f_cur2', table: 'T_APHD' }),
        'invDBCur3': new DBMappingInfo({ field: 'f_cur3', table: 'T_APHD' }),
        'invDBCur4': new DBMappingInfo({ field: 'f_cur4', table: 'T_APHD' }),
        'exRate1': new DBMappingInfo({ field: 'f_exrate1', table: 'T_APHD' }),
        'exRate2': new DBMappingInfo({ field: 'f_exrate2', table: 'T_APHD' }),
        'exRate3': new DBMappingInfo({ field: 'f_exrate3', table: 'T_APHD' }),
        'exRate4': new DBMappingInfo({ field: 'f_exrate4', table: 'T_APHD' }),
        'tVatAmt': new DBMappingInfo({ field: 'f_tvatamt', table: 'T_APHD' }),
        'tlAmount': new DBMappingInfo({ field: 'f_tlamount', table: 'T_APHD' }),
        'payGlNo': new DBMappingInfo({ field: 'f_payglno', table: 'T_APHD' }),
        'descript': new DBMappingInfo({ field: 'f_descript', table: 'T_APHD' }),
        'dutyAmt': new DBMappingInfo({ field: 'f_dutyamt', table: 'T_APHD' }),
        'dutyLAmt': new DBMappingInfo({ field: 'f_dutylamt', table: 'T_APHD' }),
        'cAmount': new DBMappingInfo({ field: 'f_camount', table: 'T_APHD' }),
        'agent': new DBMappingInfo({ field: 'F_Agent', table: 'T_APHD' }),
        'hold': new DBMappingInfo({ field: 'F_Hold', table: 'T_APHD' }),
        'holdReason': new DBMappingInfo({ field: 'F_HoldReason', table: 'T_APHD' }),
        'holdUser': new DBMappingInfo({ field: 'F_HoldUser', table: 'T_APHD' }),
        'remarksYN': new DBMappingInfo({ field: 'F_RemarksYN', table: 'T_APHD' }),
        'remarks': new DBMappingInfo({ field: 'F_Remarks', table: 'T_APHD' }),
        'remarkUser': new DBMappingInfo({ field: 'F_RemkUser', table: 'T_APHD' }),
        'approved': new DBMappingInfo({ field: 'F_Approved', table: 'T_APHD' }),
        'approvedUser': new DBMappingInfo({ field: 'F_ApprovedUser', table: 'T_APHD' }),
        'appPaidDate': new DBMappingInfo({ field: 'F_AppPaidDate', table: 'T_APHD' }),
        'branch': new DBMappingInfo({ field: 'F_ApBranch', table: 'T_APHD' }),
        'u1Id': new DBMappingInfo({ field: 'f_u1id', table: 'T_APHD' }),
        'u1Date': new DBMappingInfo({ field: 'f_u1date', table: 'T_APHD' }),
        'u2Id': new DBMappingInfo({ field: 'f_u2id', table: 'T_APHD' }),
        'u2Date': new DBMappingInfo({ field: 'f_u2date', table: 'T_APHD' }),
        'draft': new DBMappingInfo({ field: 'f_draft', table: 'T_APHD' }),
        'attentionTo': new DBMappingInfo({ field: 'AttTo', table: 'T_APHD' }),
        'ePayId': new DBMappingInfo({ field: 'F_EPayId', table: 'T_APHD' }),
        'ePayType': new DBMappingInfo({ field: 'F_EPayType', table: 'T_APHD' }),
    };

    setChildTrackable(value: boolean): void {
        if(this.billDetail.length > 0) {
            this.billDetail.forEach(c => c.trackable = value);
        }
    }

    private static ExportCollection: XCol.XExportColumn[] = [ //for list sorting when header click
        XCol.Create({ col: 0, text: '', width: 10, dataIndex: 'billNo', }),
        XCol.Create({ col: 1, text: '', width: 10, dataIndex: 'billDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 2, text: '', width: 10, dataIndex: 'vendorName' }),
        XCol.Create({ col: 3, text: '', width: 10, dataIndex: 'billReceived', type: XCol.XCellType.StrBool }),
        XCol.Create({ col: 4, text: '', width: 10, dataIndex: 'dueDate', type: XCol.XCellType.Date }),
        XCol.Create({ col: 5, text: '', width: 10, dataIndex: 'paid'}),
        XCol.Create({ col: 6, text: '', width: 10, dataIndex: 'hold', type: XCol.XCellType.StrBool }),
        XCol.Create({ col: 7, text: '', width: 10, dataIndex: 'draft', type: XCol.XCellType.StrBool }),
        XCol.Create({ col: 8, text: '', width: 10, dataIndex: 'currency' }),
        XCol.Create({ col: 9, text: '', width: 10, dataIndex: 'billAmt', type: XCol.XCellType.Double }),
        XCol.Create({ col: 10, text: '', width: 10, dataIndex: 'paidAmt', type: XCol.XCellType.Double }),
        XCol.Create({ col: 11, text: '', width: 10, dataIndex: 'balanceDue', type: XCol.XCellType.Double }),
        XCol.Create({ col: 22, text: '', width: 10, dataIndex: 'crDbNo' }),
    ];

    public static getExportCollection(): XCol.XExportColumn[] { //for list sorting when header click
        return this.ExportCollection;
    };
}
